// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__27K_m","errorLogs":"EditorFooter_errorLogs__w_S_A"};